// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2McLD","content":"GlobalSearch_content__3suza"};